import classNames from "classnames";
import TextInput from "components/input/TextInput";
import { useEffect, useRef, useState } from "react";
import { FiSearch } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import SearchDropdown from "./SearchDropdown";

type SearchBoxProps = {
  className?: string;
  disabled?: boolean;
  state?: string;
  placeholder?: string;
};

function useOutsideAlerter(ref: any, setX: any): void {
  useEffect(() => {
    /**
     * Alert if clicked on outside of element
     */
    // function handleClickOutside(event: React.MouseEvent<HTMLElement>) {
    function handleClickOutside(event: any) {
      if (ref.current && !ref.current.contains(event.target)) {
        setX(false);
      }
    }
    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref, setX]);
}

const SearchBox = (props: SearchBoxProps) => {
  const { className, disabled, state, placeholder = "Search" } = props;
  const navigate = useNavigate();

  const [query, setQuery] = useState("");
  const [openWrapper, setOpenWrapper] = useState(false);
  const [selected, setSelected] = useState(null);

  const wrapperRef = useRef(null);
  useOutsideAlerter(wrapperRef, setOpenWrapper);

  return (
    <div
      ref={wrapperRef}
      className={classNames({
        relative: true,
        [className]: className,
      })}
    >
      <TextInput
        value={query}
        className={`text-small flex w-full items-center justify-center rounded-[10px] bg-white p-3 !pr-12 outline-none dark:bg-gray-900 ${
          disabled === true
            ? "!border-none !bg-gray-100 dark:!bg-white/5 dark:placeholder:!text-[rgba(255,255,255,0.15)]"
            : state === "error"
            ? "border-red-500 text-red-500 placeholder:text-red-500 dark:!border-red-400 dark:!text-red-400 dark:placeholder:!text-red-400"
            : state === "success"
            ? "border-green-500 text-green-500 placeholder:text-green-500 dark:!border-green-400 dark:!text-green-400 dark:placeholder:!text-green-400"
            : "border-gray-200 dark:!border-white/10 dark:text-white"
        }`}
        placeholder={placeholder}
        onClick={() => setOpenWrapper(true)}
        onChange={(e) => {
          const strim = e.target.value.replace(/[^a-zA-Z0-9]/g, "");
          setOpenWrapper(true);
          setQuery(strim);
        }}
        onKeyDown={(e) => {
          if (e.key === "Escape") {
            e.preventDefault();
            setOpenWrapper(false);
          }
          if (e.key === "Enter") {
            e.preventDefault();

            if (selected) {
              navigate(selected.path);
              setOpenWrapper(false);
            }
          }
        }}
      />
      <button className="btn text-xsmall absolute right-[14px] top-[12px] !rounded !p-[2px]">
        <FiSearch />
      </button>

      {openWrapper && (
        <div
          className={`box absolute left-[0] top-[42px] z-[9999] w-full origin-top bg-gray-50 py-5 transition-all duration-300 ease-in-out dark:bg-darkGrey ${
            openWrapper ? "scale-100" : "scale-y-0"
          }`}
        >
          {<SearchDropdown query={query} setSelected={setSelected} />}
        </div>
      )}
    </div>
  );
};

export default SearchBox;
